import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useLanguage } from "../lib/language";

export const Impressum = () => {
  const { t, lang } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isDE = lang === "de";

  return (
    <main
      data-testid="impressum-page"
      className="bg-resilie-bg text-resilie-ink min-h-screen"
    >
      <Header forceLight={true} />

      <article className="px-6 md:px-12 pt-32 md:pt-40 pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto">
          {/* Back link */}
          <Link
            to="/"
            data-testid="impressum-back-link"
            className="nav-link inline-flex items-center gap-2 text-resilie-muted hover:text-resilie-ink"
          >
            ← {isDE ? "Zurück" : "Back"}
          </Link>

          {/* Kicker */}
          <p
            data-testid="impressum-kicker"
            className="mt-12 font-sans text-[10px] md:text-[11px] tracking-[0.5em] uppercase text-resilie-muted"
          >
            — {isDE ? "Rechtliches" : "Legal"} —
          </p>

          {/* Title */}
          <h1
            data-testid="impressum-title"
            className="mt-6 font-serif font-light leading-[1.05] tracking-tight text-resilie-ink
                       text-4xl sm:text-5xl md:text-6xl"
          >
            {t.impressum.title}
          </h1>

          <hr className="mt-12 border-resilie-line" />

          {/* Body */}
          <div className="mt-12 space-y-12 font-sans text-[15px] leading-[1.85] text-resilie-ink/85">

            <section data-testid="impressum-tmg">
              <h2 className="font-sans text-[10px] tracking-[0.4em] uppercase text-resilie-muted mb-4">
                {t.impressum.tmg_heading}
              </h2>
              <p className="font-serif text-[22px] md:text-[26px] leading-[1.35] font-light text-resilie-ink">
                Maison Resilié GmbH
              </p>
              <p className="mt-2">
                Wellekamp 21<br />
                38440 Wolfsburg<br />
                {isDE ? "Deutschland" : "Germany"}
              </p>
            </section>

            <section data-testid="impressum-represented">
              <h2 className="font-sans text-[10px] tracking-[0.4em] uppercase text-resilie-muted mb-4">
                {t.impressum.represented_heading}
              </h2>
              <p>
                Benjamin Hoffmann<br />
                El Mehdi Benzeroual<br />
                Mustapha Harkaoui
              </p>
            </section>

            <section data-testid="impressum-contact">
              <h2 className="font-sans text-[10px] tracking-[0.4em] uppercase text-resilie-muted mb-4">
                {t.impressum.contact_heading}
              </h2>
              <p>
                {isDE ? "E-Mail" : "Email"}:{" "}
                <a
                  href="mailto:info@resilie.de"
                  className="underline-offset-4 hover:underline"
                  data-testid="impressum-email"
                >
                  info@resilie.de
                </a>
                <br />
                {isDE ? "Telefon" : "Phone"}: {t.impressum.phone_pending}
              </p>
            </section>

            <section data-testid="impressum-vat">
              <h2 className="font-sans text-[10px] tracking-[0.4em] uppercase text-resilie-muted mb-4">
                {t.impressum.vat_heading}
              </h2>
              <p>{t.impressum.vat_pending}</p>
            </section>

            <section data-testid="impressum-responsible">
              <h2 className="font-sans text-[10px] tracking-[0.4em] uppercase text-resilie-muted mb-4">
                {t.impressum.responsible_heading}
              </h2>
              <p>
                Benjamin Hoffmann<br />
                Wellekamp 21<br />
                38440 Wolfsburg
              </p>
            </section>

            <section data-testid="impressum-eu-dispute">
              <h2 className="font-sans text-[10px] tracking-[0.4em] uppercase text-resilie-muted mb-4">
                {t.impressum.eu_heading}
              </h2>
              <p>
                {t.impressum.eu_text_pre}{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noreferrer"
                  className="underline-offset-4 hover:underline"
                  data-testid="impressum-odr-link"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                . {t.impressum.eu_text_post}
              </p>
              <p className="mt-4">{t.impressum.consumer_arbitration}</p>
            </section>

            <section data-testid="impressum-liability">
              <h2 className="font-sans text-[10px] tracking-[0.4em] uppercase text-resilie-muted mb-4">
                {t.impressum.liability_heading}
              </h2>
              <p>{t.impressum.liability_content}</p>
              <p className="mt-4">{t.impressum.liability_links}</p>
            </section>

            <section data-testid="impressum-copyright">
              <h2 className="font-sans text-[10px] tracking-[0.4em] uppercase text-resilie-muted mb-4">
                {t.impressum.copyright_heading}
              </h2>
              <p>{t.impressum.copyright_text}</p>
            </section>

          </div>
        </div>
      </article>

      <Footer />
    </main>
  );
};

export default Impressum;
